import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		count: 0,
		game_id: 0
	},
	mutations: {
		set_game_id(state, game_id) {
			state.game_id = game_id;
		}
	}
});



// WEBPACK FOOTER //
// ./src/store/index.js